import { Link, useLocation } from 'react-router-dom';

import PropTypes from 'prop-types';

import { resolveNavItem } from '#globalComponents/Sidebar/navItems';

const Breadcrumbs = ({ breadcrumbs }) => (
	<nav className="flex items-center gap-1.5 text-xs text-bgBase-600 min-w-0">
		<Link to="/">Home</Link>
		{breadcrumbs.map((crumb, i) => {
			const isLast = i === breadcrumbs.length - 1;
			const label = typeof crumb === 'string' ? crumb : crumb.label;
			const to = typeof crumb === 'object' ? crumb.to : undefined;

			return (
				<span key={i} className="flex items-center gap-1.5 min-w-0">
					<span className="select-none">/</span>
					{!isLast && to ? (
						<Link to={to} className="truncate">
							{label}
						</Link>
					) : (
						<span className={`truncate ${isLast ? 'font-medium' : ''}`}>{label}</span>
					)}
				</span>
			);
		})}
	</nav>
);

Breadcrumbs.propTypes = {
	breadcrumbs: PropTypes.array.isRequired,
};

const PageHeader = ({ breadcrumbs = [], title, subtitle, children }) => {
	const { pathname } = useLocation();
	const navItem = resolveNavItem(pathname);

	const headline = title ?? navItem?.label;
	const description = subtitle ?? (title ? undefined : navItem?.sub);

	return (
		<div className="flex items-center h-20 gap-4 mb-5">
			<div className="flex flex-col gap-2 min-w-0">
				{headline && (
					<h1 className="text-lg font-semibold leading-none truncate min-w-0">
						{headline}
						{description && <span className="font-light hidden sm:inline"> – {description}</span>}
					</h1>
				)}
				{breadcrumbs.length > 0 && <Breadcrumbs breadcrumbs={breadcrumbs} />}
			</div>
			{children && <div className="flex items-center gap-2 ml-auto flex-shrink-0">{children}</div>}
		</div>
	);
};

PageHeader.propTypes = {
	breadcrumbs: PropTypes.arrayOf(
		PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.shape({ label: PropTypes.string.isRequired, to: PropTypes.string }),
		]),
	),
	title: PropTypes.string,
	subtitle: PropTypes.string,
	children: PropTypes.node,
};

export default PageHeader;
